import React from "react";
import SearchBar from "./PackageToolbar/SearchBar";
import PackageFilters from "./PackageToolbar/PackageFilters";
import { Button } from "@/components/ui/button";
import { Download, PackagePlus, LayoutList, Grid2x2 } from "lucide-react";

interface PackageToolbarProps {
  onNewPackage: () => void;
  onGenerateReport: () => void;
  view: "list" | "grid";
  onToggleView: (view: "list" | "grid") => void;
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  statusFilter: string;
  setStatusFilter: (s: string) => void;
  startDate: string | null;
  setStartDate: (d: string | null) => void;
  endDate: string | null;
  setEndDate: (d: string | null) => void;
}

const PackageToolbar = ({
  onNewPackage,
  onGenerateReport,
  view,
  onToggleView,
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate
}: PackageToolbarProps) => {
  return (
    <div className="w-full space-y-2 mb-4">
      {/* First line: Search, Date Range, Status Filter */}
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
        <div className="flex-1 flex gap-2 items-center">
          <div className="w-full max-w-xs">
            <SearchBar value={searchQuery} onChange={setSearchQuery} />
          </div>
          {/* Date & status filters */}
          <PackageFilters
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>
      </div>
      {/* Second line: View Toggles, Report, New Package */}
      <div className="flex flex-row justify-between items-center gap-2">
        {/* List/Grid view toggles */}
        <div className="flex gap-2">
          <div className="inline-flex border rounded-md overflow-hidden">
            <Button
              variant={view === "list" ? "default" : "outline"}
              className="rounded-none"
              onClick={() => onToggleView("list")}
            >
              <LayoutList size={16} className="mr-1" />
              List
            </Button>
            <Button
              variant={view === "grid" ? "default" : "outline"}
              className="rounded-none"
              onClick={() => onToggleView("grid")}
            >
              <Grid2x2 size={16} className="mr-1" />
              Grid
            </Button>
          </div>
        </div>
        {/* Actions: Generate Report, New Package */}
        <div className="flex gap-2">
          <Button onClick={onGenerateReport} className="flex items-center bg-primary text-primary-foreground font-semibold px-4 py-2 rounded-md hover:bg-primary/90 transition-colors" size="sm">
            <Download className="mr-2 h-4 w-4" />
            Generate Report
          </Button>
          <Button onClick={onNewPackage} className="flex items-center bg-primary text-primary-foreground font-semibold px-4 py-2 rounded-md hover:bg-primary/90 transition-colors" size="sm">
            <PackagePlus className="mr-2 h-4 w-4" />
            New Package
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PackageToolbar;
